import api from "../store/services/api";

export const checkIfoodShippingStatus = (params) =>
  api.get("/orders/shipping/ifood/status/", { params });

export const postShippingOrder = (params) =>
  api.post(
    "/orders/shipping/create/",
    {},
    {
      params,
      headers: { "Content-Type": "application/json" },
    }
  );

export const sendIfoodDeliveryConfirmationCode = (body) =>
  api.post("/orders/shipping/ifood/confirmation-code/", body, {
    headers: { "Content-Type": "application/json" },
  });

export const cancelIfoodOrderRequest = (params) =>
  api.post(
    "/orders/shipping/cancel/",
    {},
    {
      params,
      headers: { "Content-Type": "application/json" },
    }
  );

export const getShippingRoutes = (params) =>
  api.get("/shipping/routes/", { params });

export const getShippingRoutesHistoryReport = (params) =>
  api.get("/shipping/routes/history-report/", { params });

export const getActiveShippingRoutes = () =>
  api.get("/shipping/routes/?status=1");

export const editShippingRoute = (selectedRouteId, driverId) =>
  api.put("/shipping/routes/", {
    id: selectedRouteId,
    fk_driver: driverId,
  });

export const dispatchShippingRoute = (params) =>
  api.put("/shipping/routes/dispatch/", {}, { params });

export const confirmShippingRouteDelivery = (params) =>
  api.put("/shipping/routes/confirm-delivery/", {}, { params });

export const deleteShippingRoute = (shippingRouteId) =>
  api.delete(`/shipping/routes/?rid=${shippingRouteId}`);

export const deleteShippingRouteOrder = (shippingRouteOrderId) =>
  api.delete(`/shipping/routes/orders/?sroid=${shippingRouteOrderId}`);

export const getPreparingOrdersMatrix = (params) =>
  api.get("/shipping/routes/orders/matrix/", { params });

export const postShippingRouteOrder = (body) =>
  api.post("/shipping/routes/orders/", body);

export const getShippingRouteOrderReturnPaymentPending = async (
  shippingRouteId
) =>
  await api.get(`/shipping/routes/orders/payment/pending/${shippingRouteId}/`);

export const routeOptimizer = () =>
  api.get("/shipping-route/manager/optimize/");

export const getRouteOptimizerResult = () =>
  api.get("/shipping-route/manager/result/");

export const getDispatchSummary = (params) =>
  api.get("/shipping/routes/dispatch-summary/", { params });

const ShippingService = {
  checkIfoodShippingStatus,
  postShippingOrder,
  cancelIfoodOrderRequest,
  getActiveShippingRoutes,
  editShippingRoute,
  dispatchShippingRoute,
  deleteShippingRoute,
  deleteShippingRouteOrder,
  getShippingRouteOrderReturnPaymentPending,
  sendIfoodDeliveryConfirmationCode,
};

export default ShippingService;
